"use client";
import React, { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
// import "react-jquery-plugin";
import "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel"; // This line will be replaced by dynamic import
import Link from "next/link";
import { useRouter } from "next/navigation";
import { AppContext } from "../context/AppContext";
import { useContext } from "react";
import { GameContext } from "../context/GameContext";
import Image from "next/image";

// const owlCarousel = dynamic(import("react-owl-carousel"), { ssr: !!false });
const owlCarousel = dynamic(import("react-owl-carousel"), { ssr: true });

// function getCategoryPath(categoryId, categories) {
//   const category = categories.find((cat) => cat.categoryId === categoryId);
//   return category ? category.path : "";
// }

const CarouselOwlHGames = ({ games = [] }) => {
  // console.log("GAMES:::::", games);

  const { gamesCategories, gamesSubCategories } = useContext(AppContext);
  // const { user, setIsClosed, games } = useContext(AppContext);
  const { user, setIsClosed } = useContext(AppContext);
  const { startGame } = useContext(GameContext);
  const router = useRouter();
  const lastGamesCarouselRef = useRef(null);
  const topGamesCarouselRef = useRef(null);
  const tableGamesCarouselRef = useRef(null);
  const { setSelectedGame } = useContext(GameContext);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    if (gamesCategories.length > 0) {
      setSelectedCategory(gamesCategories[2].categoryId);
    }
  }, [gamesCategories]);

  useEffect(() => {
    if (typeof window !== "undefined" && games?.length > 0) {
      const $lastGamesCarousel = $(lastGamesCarouselRef.current);
      const $topGamesCarousel = $(topGamesCarouselRef.current);
      const $tableGamesCarousel = $(tableGamesCarouselRef.current);
      $lastGamesCarousel.owlCarousel({
        loop: true,
        margin: 0,
        autoplay: false,
        responsive: {
          1600: {
            items: 8.5,
            margin: 10,
          },
          1150: {
            items: 6.5,
            margin: 5,
          },
          768: {
            items: 7,
            margin: 5,
          },
          0: {
            items: 7,
            margin: 5,
          },
        },
      });

      $topGamesCarousel.owlCarousel({
        loop: true,
        margin: 0,
        autoplay: false,
        responsive: {
          1600: {
            items: 8.5,
            margin: 10,
          },
          1150: {
            items: 6.5,
            margin: 5,
          },
          768: {
            items: 5.5,
            margin: 5,
          },
          0: {
            items: 7,
            margin: 5,
          },
        },
      });

      $tableGamesCarousel.owlCarousel({
        loop: true,
        margin: 0,
        autoplay: false,
        responsive: {
          1600: {
            items: 8.5,
            margin: 10,
          },
          1150: {
            items: 6.5,
            margin: 5,
          },
          768: {
            items: 5.5,
            margin: 5,
          },
          0: {
            items: 7,
            margin: 5,
          },
        },
      });

      $("#Nav_L_LG").on("click", function (e) {
        e.preventDefault();
        $lastGamesCarousel.trigger("prev.owl.carousel");
        $lastGamesCarousel.trigger("stop.owl.autoplay");
      });
      $("#Nav_R_LG").on("click", function (e) {
        e.preventDefault();
        $lastGamesCarousel.trigger("next.owl.carousel");
        $lastGamesCarousel.trigger("stop.owl.autoplay");
      });
      $("#Nav_L_TG").on("click", function (e) {
        e.preventDefault();
        $topGamesCarousel.trigger("prev.owl.carousel");
        $topGamesCarousel.trigger("stop.owl.autoplay");
      });
      $("#Nav_R_TG").on("click", function (e) {
        e.preventDefault();
        $topGamesCarousel.trigger("next.owl.carousel");
        $topGamesCarousel.trigger("stop.owl.autoplay");
      });
      $("#Nav_L_TAG").on("click", function (e) {
        e.preventDefault();
        $tableGamesCarousel.trigger("prev.owl.carousel");
        $tableGamesCarousel.trigger("stop.owl.autoplay");
      });
      $("#Nav_R_TAG").on("click", function (e) {
        e.preventDefault();
        $tableGamesCarousel.trigger("next.owl.carousel");
        $tableGamesCarousel.trigger("stop.owl.autoplay");
      });
    }
  }, [games]);

  function formatGameName(name) {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9/]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  const openModal = (game) => {
    setSelectedGame(game);
    router.push(`/${formatGameName(game.displayName)}`);
  };

  return (
    <>
      <div id="MainContHomeGames">
        <div className="RowWPG_Caro LastGames">
          {/* NAV */}
          <div className="TitleNavCaro">
            <div className="TitleCat">
              <p className="TitleCatHGames">Latest Games</p>
            </div>
            <div className="BControlsCaro">
              <div className="ArrowNav Nav_L" id="Nav_L_LG"></div>
              <div className="ArrowNav Nav_R" id="Nav_R_LG"></div>
            </div>
          </div>
          <div className="owl-carousel" ref={lastGamesCarouselRef}>
            {games?.length > 0 &&
              games
                .sort(
                  (value1, valu2) =>
                    new Date(valu2.created) - new Date(value1.created)
                )
                .slice(0, 20)
                .filter((value) => value.categoryIds.includes(8))
                .map((value, index) => (
                  <div
                    rel="noopener noreferrer"
                    key={index}
                    onClick={() => openModal(value)}
                  >
                    <div className="item">
                      <Image
                        width={250}
                        height={350}
                        src={value.gameImageUrl}
                        alt={value.displayName}
                      />
                    </div>
                  </div>
                ))}
          </div>
        </div>

        <div className="RowWPG_Caro TableGames">
          {/* NAV */}
          <div className="TitleNavCaro">
            <div className="TitleCat">
              <p className="TitleCatHGames">Table Games</p>
            </div>
            <div className="BControlsCaro">
              <div className="ArrowNav Nav_L" id="Nav_L_TAG"></div>
              <div className="ArrowNav Nav_R" id="Nav_R_TAG"></div>
            </div>
          </div>
          <div className="owl-carousel" ref={tableGamesCarouselRef}>
            {games?.length > 0 &&
              games
                .filter((value) => value.categoryIds.includes(2))
                .map((value, index) => (
                  <div key={index} onClick={() => openModal(value)}>
                    <div className="item">
                      <Image
                        width={250}
                        height={350}
                        src={value.gameImageUrl}
                        alt={value.displayName}
                      />
                    </div>
                  </div>
                ))}
          </div>
        </div>

        <Link href="/games" className="BtnViewAll Cyan">
          View All Games!
        </Link>
      </div>
    </>
  );
};

export default CarouselOwlHGames;
